import React from 'react'
import PropTypes from 'prop-types'
import ItemRow from './ItemRow'
import {canViewStoreName} from '../../../services/StorageServices'

class TableBody extends React.Component {
    render() {
        const {
            items,
            reloadItems,
            selectedItems,
            handleChangeSelected,
            openModalEdit,
            openModalEditProduct,
            openModalMarkFaileDesign,
            itemsRequest,
            onModalItemLabel,
            onChangeFilterTag,
            openModalGenLabelCustomWHL,
            filter,
            onChangeFilter
        } = this.props

        const parsedItems = items.filter(item => {
            let products = item.products

            if (item.hasOwnProperty('filteredProducts')) {
                products = item.filteredProducts
            }

            return !(!Array.isArray(products) || products.length === 0)
        })

        const canViewStore = canViewStoreName()

        return (
            <div>
                {
                    parsedItems.length > 0 ? parsedItems.map((item, i) => {
                        return <ItemRow
                            key={i}
                            index={i}
                            item={item}
                            canViewStore={canViewStore}
                            isSelected={selectedItems[item._id]}
                            reloadItems={reloadItems}
                            openModalEdit={openModalEdit}
                            openModalEditProduct={openModalEditProduct}
                            onChangeSelected={handleChangeSelected}
                            openModalMarkFaileDesign={openModalMarkFaileDesign}
                            itemsRequest={itemsRequest}
                            onModalItemLabel={onModalItemLabel}
                            onChangeFilterTag={onChangeFilterTag}
                            openModalGenLabelCustomWHL={openModalGenLabelCustomWHL}
                            filter={filter}
                            onChangeFilter={onChangeFilter}
                        />
                    })
                        : <div>
                            <div>Không có dữ liệu</div>
                        </div>
                }
            </div>
        )
    }
}

TableBody.propTypes = {
    items: PropTypes.array.isRequired,
}

export default TableBody

